import { useState } from 'react';
import { useLocalStorage } from '@vs-online-only-app/ui';
import {
  ConversationRequestEvent,
  useGetAssociateSettings,
} from '@vs-online-only-app/state';
import { addSeconds } from 'date-fns';

const useConversationRequestExpiryTime = (event: ConversationRequestEvent) => {
  const [hasClearedExpiryTime, setHasClearedExpiryTime] = useState(false);

  const { data: associateSettings } = useGetAssociateSettings();
  const { setLocalStorage, getLocalStorage, removeLocalStorage } =
    useLocalStorage();

  const conversationId = event?.conversation.id;
  const localStorageKey = `conversation.${conversationId}.request.expiryTime`;

  const getExpiryTime = () => {
    if (hasClearedExpiryTime) return undefined;

    const storedExpiryTime = getLocalStorage(localStorageKey);

    if (storedExpiryTime) return storedExpiryTime;

    if (!associateSettings) return undefined;

    const expiryTimeString = addSeconds(
      new Date(),
      associateSettings.settings.requestTimer,
    ).toISOString();

    setLocalStorage(localStorageKey, expiryTimeString);
    return expiryTimeString;
  };

  const clearExpiryTime = () => {
    setHasClearedExpiryTime(true);
    removeLocalStorage(localStorageKey);
  };

  return { clearExpiryTime, expiryTime: getExpiryTime() };
};

export default useConversationRequestExpiryTime;
